
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandJ as ObiOwnShipNoCommandJElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-j.js';
 
 
 

 
 export const ObiOwnShipNoCommandJ = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-j',
   elementClass: ObiOwnShipNoCommandJElement,
   events: {
     
   }
  });
 
 